var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.49992 15.1673C12.1818 15.1673 15.1666 12.1825 15.1666 8.50065C15.1666 4.81875 12.1818 1.83398 8.49992 1.83398C4.81802 1.83398 1.83325 4.81875 1.83325 8.50065C1.83325 12.1825 4.81802 15.1673 8.49992 15.1673Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.66732C8.77333 9.66732 9 9.44065 9 9.16732V5.83398C9 5.56065 8.77333 5.33398 8.5 5.33398C8.22667 5.33398 8 5.56065 8 5.83398V9.16732C8 9.44065 8.22667 9.66732 8.5 9.66732Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11325 10.9139C9.07992 10.8339 9.03325 10.7606 8.97325 10.6939C8.90659 10.6339 8.83325 10.5872 8.75325 10.5539C8.59325 10.4872 8.40659 10.4872 8.24659 10.5539C8.16659 10.5872 8.09325 10.6339 8.02659 10.6939C7.96659 10.7606 7.91992 10.8339 7.88659 10.9139C7.85325 10.9939 7.83325 11.0806 7.83325 11.1672C7.83325 11.2539 7.85325 11.3406 7.88659 11.4206C7.91992 11.5072 7.96659 11.5739 8.02659 11.6406C8.09325 11.7006 8.16659 11.7472 8.24659 11.7806C8.32659 11.8139 8.41325 11.8339 8.49992 11.8339C8.58659 11.8339 8.67325 11.8139 8.75325 11.7806C8.83325 11.7472 8.90659 11.7006 8.97325 11.6406C9.03325 11.5739 9.07992 11.5072 9.11325 11.4206C9.14659 11.3406 9.16659 11.2539 9.16659 11.1672C9.16659 11.0806 9.14659 10.9939 9.11325 10.9139Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.6d35338ab63a7f94b194fc43e8eed3dd.svg";
export { ForwardRef as ReactComponent };